import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500">
              关于吃瓜群的常见疑问，这里一次性为你解答
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item) => (
              <div
                key={item.id}
                className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => setOpenId(openId === item.id ? null : item.id)}
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer hover:bg-background-200/50 transition-colors"
                >
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {item.question}
                  </h3>
                  <span className={`flex-shrink-0 transition-transform duration-300 ${
                    openId === item.id ? 'rotate-180' : ''
                  }`}>
                    <i className="ri-arrow-down-s-line text-lg text-foreground-500" />
                  </span>
                </button>
                {openId === item.id && (
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}